// <<<<<<< day-2-abdul

import './App.css';

import React from 'react';
import './styles.css';
import {AllRoutes} from './routes/Allroutes';


function App() {
  return (
    <div className="App">

      <AllRoutes/>

    </div>
  );
}

export default App;
